<template>
  <div class="bg-white rounded-2xl shadow-md p-4">
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-lg font-bold text-gray-900">Franchise</h3>
      <span :class="['inline-flex items-center px-3 py-0.5 rounded-full text-xs font-medium', statusClass]">
        {{ $t(`claim_deductible.status.${claimDeductible.status}`) }}
      </span>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
      <StackedField label="Montant" :value="formatPrice(claimDeductible.price)" />
      <StackedField v-if="paid" label="Facture">
        <button @click="handleInvoiceClick" class="text-sm text-blue-400 underline cursor-pointer">
          Lien de la facture
        </button>
      </StackedField>
    </div>
  </div>
</template>

<script>
import { formatPrice, StackedField, toCamelCase } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["claimDeductible"],
  components: {
    StackedField,
  },
  computed: {
    ...mapGetters("claimDeductibles", { deductibleIsPaid: "isPaid", deductibleStatusClass: "statusClass" }),
    paid() {
      return this.deductibleIsPaid(this.claimDeductible);
    },
    statusClass() {
      return this.deductibleStatusClass(this.claimDeductible);
    },
  },
  methods: {
    formatPrice,
    ...mapActions("claimDeductibles", ["fetchInvoiceUrl"]),
    async handleInvoiceClick() {
      const response = await this.fetchInvoiceUrl({ id: this.claimDeductible.id });
      if (!response?.success) return;

      const invoiceUrl = toCamelCase(response.data).invoiceUrl;
      if (invoiceUrl) window.open(invoiceUrl, "_blank");
    },
  },
};
</script>
